import React from 'react'
import './ToolNav.css'

function ToolNav() {
  return (
      <nav className='tool-nav'>
          <div className="logo"><img src="./assets/logo.svg" alt="" /></div>
          <div className="tip"><img src="./assets/tip.svg" alt="" /></div>
      </nav>
  )
}

export default ToolNav